import {
  GET_WORKING_HOURS,
  SET_WORKING_HOURS,
  UPDATE_WORKING_HOURS,
  SUBMIT_CLOSURES_FORM,
  CLOSURES_UPDATE,
  ADMIN_SETTINGS_DAY_FROM_UPDATE,
  ADMIN_SETTINGS_DAY_TO_UPDATE,
  ADMIN_SETTINGS_SCHEDULE_SUBMIT,
  ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE,
  HANDLE_REQUEST_CLOSE,
  ADMIN_SETTINGS_CHANGE_ADD_STATE,
  ADMIN_SETTINGS_CHANGE_EDIT_STATE,
  EDIT_CLOSURE,
  EDIT_CLOSURE_RESPONSE,
  FAIL_RESPONSE_MESSAGE,
  DELETE_CLOSURES,
  DELETE_CLOSURES_RESPONSE,
  ADMIN_SETTINGS_CANCEL_CLICK,
  CLOSURE_ON_HIDE_LOADER,
  CLOSURE_ON_SHOW_LOADER,
  WORKING_HOURS_HIDE_LOADER,
  WORKING_HOURS_SHOW_LOADER,
  DAY_ERROR,
  DAY_ERROR_RESPONSE,
  BUSINESS_PROFILE_CANCEL,
  BUSINESS_PROFILE_SAVE,
  BUSINESS_PROFILE_SAVE_RESPONSE,
  BUSINESS_PROFILE_IMAGE_FILE,
  BUSINESS_PROFILE_IMAGE_FILE_RESPONSE,
  WORKING_HOURS_TOGGLE_MODAL,
  WORKING_HOURS_NEW_REQUEST_CLOSE,
  ADMIN_SETTINGS_ON_HIDE_LOADER,
  ADMIN_SETTINGS_ON_SHOW_LOADER,
  UPDATE_WORKING_HOURS_RESPONSE,
  ADMIN_SETTINGS_DAY_FROM_UPDATE_RESPONSE,
  ADMIN_SETTINGS_DAY_TO_UPDATE_RESPONSE,
  BUSSINESS_GALLARY_IMAGE_FILE,
  BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS,
  DELETE_GALLERY_IMAGE_REQUEST,
  BUSSINESS_GALLARY_IMAGE_FILE_ERROR,
  BUSSINESS_GALLARY_IMAGE_FILE_REMOVE,
} from "../constants/ActionTypes";

export const getWorkingHours = () => ({
  type: GET_WORKING_HOURS,
});

export const setWorkingHours = payload => ({
  type: SET_WORKING_HOURS,
  payload,
});

export const submitClosuresForm = payload => ({
  type: SUBMIT_CLOSURES_FORM,
  payload,
});

export const closuresUpdate = payload => ({
  type: CLOSURES_UPDATE,
  payload,
});

export const updateWorkingHours = payload => ({
  type: UPDATE_WORKING_HOURS,
  payload,
});

export const updateWorkingHoursResponse = payload => ({
  type: UPDATE_WORKING_HOURS_RESPONSE,
  payload,
});

export const adminSettingsDayFromUpdate = payload => ({
  type: ADMIN_SETTINGS_DAY_FROM_UPDATE,
  payload,
});

export const adminSettingsDayFromUpdateResponse = payload => ({
  type: ADMIN_SETTINGS_DAY_FROM_UPDATE_RESPONSE,
  payload,
});

export const adminSettingsDayToUpdate = payload => ({
  type: ADMIN_SETTINGS_DAY_TO_UPDATE,
  payload,
});

export const adminSettingsDayToUpdateResponse = payload => ({
  type: ADMIN_SETTINGS_DAY_TO_UPDATE_RESPONSE,
  payload,
});

export const adminSettingsScheduleSubmit = payload => ({
  type: ADMIN_SETTINGS_SCHEDULE_SUBMIT,
  payload,
});

export const adminSettingsScheduleSubmitResponse = payload => ({
  type: ADMIN_SETTINGS_SCHEDULE_SUBMIT_RESPONSE,
  payload,
});

export const handleRequestCloseSetting = () => ({
  type: HANDLE_REQUEST_CLOSE,
});

export const adminSettingsChangeAddState = payload => ({
  type: ADMIN_SETTINGS_CHANGE_ADD_STATE,
  payload,
});

export const adminSettingsChangeEditState = payload => ({
  type: ADMIN_SETTINGS_CHANGE_EDIT_STATE,
  payload,
});

export const editClosure = payload => ({
  type: EDIT_CLOSURE,
  payload,
});

export const editClosureResponse = payload => ({
  type: EDIT_CLOSURE_RESPONSE,
  payload,
});

export const failResponseMessage = payload => ({
  type: FAIL_RESPONSE_MESSAGE,
  payload,
});

export const businessGallaryImageFileError = payload => ({
  type: BUSSINESS_GALLARY_IMAGE_FILE_ERROR,
  payload,
});

export const deleteClosures = payload => ({
  type: DELETE_CLOSURES,
  payload,
});

export const deleteClosuresResponse = payload => ({
  type: DELETE_CLOSURES_RESPONSE,
  payload,
});

export const adminSettingsCancelClick = () => ({
  type: ADMIN_SETTINGS_CANCEL_CLICK,
});

export const closureOnhideLoader = payload => ({
  type: CLOSURE_ON_HIDE_LOADER,
  payload,
});

export const closureOnShowLoader = payload => ({
  type: CLOSURE_ON_SHOW_LOADER,
  payload,
});

export const workingHoursHideLoader = payload => ({
  type: WORKING_HOURS_HIDE_LOADER,
  payload,
});

export const workingHoursShowLoader = payload => ({
  type: WORKING_HOURS_SHOW_LOADER,
  payload,
});

export const dayError = payload => ({
  type: DAY_ERROR,
  payload,
});

export const dayErrorDelete = payload => ({
  type: DAY_ERROR_RESPONSE,
  payload,
});

export const businessProfileCancel = payload => ({
  type: BUSINESS_PROFILE_CANCEL,
  payload,
});

export const businessProfileSave = payload => ({
  type: BUSINESS_PROFILE_SAVE,
  payload,
});

export const businessProfileSaveResponse = payload => ({
  type: BUSINESS_PROFILE_SAVE_RESPONSE,
  payload,
});

export const businessProfileImageFile = payload => ({
  type: BUSINESS_PROFILE_IMAGE_FILE,
  payload,
});

export const businessProfileImageFileResponse = payload => ({
  type: BUSINESS_PROFILE_IMAGE_FILE_RESPONSE,
  payload,
});


export const businessGallaryImageFile = payload => ({
  type: BUSSINESS_GALLARY_IMAGE_FILE,
  payload,
});

export const businessGallaryImageFileRemove = payload => ({
  type: BUSSINESS_GALLARY_IMAGE_FILE_REMOVE,
  payload,
});

export const businessGallaryImageFileSucess = payload => ({
  type: BUSSINESS_GALLARY_IMAGE_FILE_SUCCESS,
  payload,
});

export const workingHoursToggleModal = payload => ({
  type: WORKING_HOURS_TOGGLE_MODAL,
  payload,
});

export const workingHoursNewRequestClose = payload => ({
  type: WORKING_HOURS_NEW_REQUEST_CLOSE,
  payload,
});

export const adminSettingsOnHideLoader = payload => ({
  type: ADMIN_SETTINGS_ON_HIDE_LOADER,
  payload,
});

export const adminSettingsOnShowLoader = payload => ({
  type: ADMIN_SETTINGS_ON_SHOW_LOADER,
  payload,
});

export const deleteGalleryImage = payload => ({
  type: DELETE_GALLERY_IMAGE_REQUEST,
  payload
})


// WEBPACK FOOTER //
// ./actions/AdminSettings.js